







import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "../fixedPhrase/FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "../fixedPhrase/mixins";
import { IEditFixedPhrase } from "../fixedPhrase/IEditFixedPhrase";
import { FixedPhraseKinds } from "../fixedPhrase/FixedPhraseKinds";
import { AiFixedPhraseSelectorMixin } from "./mixins";
import { AiSyntaxDialog } from "./dialogs";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
    AiSyntaxDialog,
  }
})
export default class AiFormatFixedPhraseSelector extends Mixins(
  AiFixedPhraseSelectorMixin,
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  formatOriginalId: number;

  @Prop({ default: true })
  isPastable: boolean;

  get formatOriginalIdText(): string {
    return (this.formatOriginalId == null || this.formatOriginalId === -1)
      ? null
      : this.formatOriginalId.toString();
  }

  created(): void {
    this.loadFixedPhrase();
  }

  private async loadFixedPhrase(): Promise<void> {
    this.$logger.debug("loadFixedPhrase() formatOriginalId=" + this.formatOriginalId);
    try {
      if (!this.formatOriginalIdText) {
        // 文書情報（フォーマット情報）取得完了前に読み込みされる場合はformatOriginalId=-1となってしまっている模様
        return;
      }
      this.rootFixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.AiFormat, this.formatOriginalIdText);
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "書類生成AI定型文取得失敗",
        "書類生成AI定型文を読み込めませんでした。",
        e);
    }
  }

  @Watch("formatOriginalId")
  onFormatOriginalIdUpdated(newValue: number, oldValue: number): void {
    this.$logger.debug("onFormatOriginalIdUpdated() newValue=" + newValue + ", oldValue=" + oldValue);
    this.loadFixedPhrase();
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.AiFormat, isForcibly, this.formatOriginalIdText), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.AiFormat, this.formatOriginalIdText);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.AiFormat, this.formatOriginalIdText, this.aiFixedPhraseOptions);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.AiFormat, result);
  }
}
